import {useState, useLayoutEffect} from 'react';

const useIsFirefoxBrowser = () => {
	const [isFirefox, setIsFirefox] = useState(null);

	useLayoutEffect(() => {
		const userAgent = navigator.userAgent.toLowerCase();
		const isFirefoxBrowser =
			userAgent.includes('firefox') && !userAgent.includes('seamonkey');
		setIsFirefox(isFirefoxBrowser);
	}, []);

	return isFirefox;
};

export default useIsFirefoxBrowser;